import { Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import {
  NotApplicableIconLightTheme,
  NotApplicableIconDarkTheme,
} from './NotApplicableIcon';
import { useStyles } from '../../styles';
import CONSTANTS from '../../../constants';

const { QESCORE_CONTACT_EMAIL, QESCORE_HELP_URL } = CONSTANTS.QESCORE;

export function NotApplicable() {
  const classes = useStyles();
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  return (
    <div className={classes.notApplicableRoot}>
      <div className={classes.notApplicableIconWrapper}>
        {isDark ? (
          <NotApplicableIconDarkTheme fontSize="large" />
        ) : (
          <NotApplicableIconLightTheme fontSize="large" />
        )}
      </div>

      <Typography variant="h6" className={classes.notApplicableTitle}>
        QE Score marked not applicable for this application
      </Typography>

      <div className={classes.notApplicableDivider} />

      <Typography variant="body2" className={classes.notApplicableBody}>
        To learn what a QE Score is, view{' '}
        <a
          href={QESCORE_HELP_URL}
          className={classes.notApplicableLink}
          target="_blank"
          rel="noreferrer"
        >
          Help
        </a>
      </Typography>

      <Typography variant="body2" className={classes.notApplicableBody}>
        To activate, email{' '}
        <a
          href={`mailto:${QESCORE_CONTACT_EMAIL}`}
          className={classes.notApplicableLink}
        >
          {QESCORE_CONTACT_EMAIL}
        </a>
      </Typography>
    </div>
  );
}
